var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(_vm._s(_vm.getIsBackName())+"撤回了一条消息 "),(_vm.message.messageType == 'txt' && _vm.message.belong)?_c('span',{staticStyle:{"color":"#166ded","margin-left":"32rpx"},on:{"click":function($event){return _vm.setValues()}}},[_vm._v("重新编辑")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }